import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPutMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleDeleteOperator = async (operator_id, dispatch) => {
  dispatch(setShowPreloader(true));
  const DeleteRes = await AxiosPutMethod("org/delete/operator", {
    operator_id,
  });
  dispatch(setShowPreloader(false));
  if (DeleteRes.status === 200) {
    SuccessToast("Enterprise Deleted!");
    return true;
  } else {
    if (DeleteRes.status === 401) HandleLogout();
    ErrorToast("Error on Delete Enterprise");
    return null;
  }
};

export default handleDeleteOperator;
